//
// Every component in this repository needs a unique identifier
// to be used with `react-css-themr`, this opens up the possibility
// for users of the UI to override default css from the UI and
// create custom themes / components.
//
export default {
  App: 'fox-com/App',
  Auth: {
    Shared: 'fox-com/Auth/Shared',
  },
  ContentDetail: {
    VideosTab: {
      VideoTile: 'fox-com/ContentDetail/VideosTab/VideoTile',
    },
  },
  HeaderImageTitle: 'fox-com/HeaderImageTitle',
  Live: {
    Dropdown: 'fox-com/Live/Dropdown',
    DropdownPrimetime: 'fox-com/Live/DropdownPrimetime',
  },
  PromoList: 'fox-com/PromoList',
  SeriesDetail: {
    VideosTab: {
      VideoTile: 'fox-com/SeriesDetail/VideosTab/VideoTile',
      default: 'fox-com/SeriesDetail/VideosTab',
    },
  },
  StringList: 'fox-com/StringList',
  VideoPlayer: 'fox-com/VideoPlayer',
};
